import { featureFlags } from 'client/store/modules/FeatureFlagsModule';
import { mapGetters } from 'vuex';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

export const scimAppsDictionary = {
  getAppsWithScimSupport() {
    return {
      '15five': {
        learnMore: KbArticleUrls.scim15five,
      },
      '1password': {
        learnMore: KbArticleUrls.scim1password,
      },
      '4me': {
        betaScim: true,
        learnMore: KbArticleUrls.scim4me,
      },
      '8x8': {
        learnMore: KbArticleUrls.scim8x8,
        betaScim: true,
      },
      'aws-sso': {
        learnMore: KbArticleUrls.scimAwsSSO,
      },
      'github-com': {
        learnMore: KbArticleUrls.scimGitHub,
      },
      alexishr: {
        learnMore: KbArticleUrls.scimAlexisHR,
        betaScim: true,
      },
      altium: {
        learnMore: KbArticleUrls.scimAltium,
        betaScim: true,
      },
      amplitude: {
        learnMore: KbArticleUrls.scimAmplitude,
        betaScim: true,
      },
      asana: {
        learnMore: KbArticleUrls.scimAsana,
        betaScim: true,
      },
      atlassiancloud: {
        learnMore: KbArticleUrls.scimAtlassianCloud,
      },
      autodesk: {
        betaScim: true,
        learnMore: KbArticleUrls.scimAutodesk,
      },
      bitwarden: {
        learnMore: KbArticleUrls.scimBitwarden,
      },
      blink: {
        betaScim: true,
        learnMore: KbArticleUrls.scimBlink,
      },
      blogin: {
        learnMore: KbArticleUrls.scimBlogIn,
      },
      bluejeans: {
        betaScim: true,
        learnMore: KbArticleUrls.scimBluejeans,
      },
      browserstack: {
        learnMore: KbArticleUrls.scimBrowserstack,
      },
      calendly: {
        learnMore: KbArticleUrls.scimCalendly,
        betaScim: true,
      },
      cinode: {
        betaScim: true,
        learnMore: KbArticleUrls.scimCinode,
      },
      ciscowebex: {
        learnMore: KbArticleUrls.scimCiscowebex,
        betaScim: true,
      },
      cloudumbrellabycisco: {
        learnMore: KbArticleUrls.scimCloudUmbrellabyCisco,
      },
      coda: {
        learnMore: KbArticleUrls.scimCoda,
        betaScim: true,
      },
      contentful: {
        learnMore: KbArticleUrls.scimContentful,
        betaScim: true,
      },
      coralogix: {
        learnMore: KbArticleUrls.scimCoralogix,
      },
      dashlane: {
        learnMore: KbArticleUrls.scimDashlane,
        betaScim: true,
      },
      databricks: {
        learnMore: KbArticleUrls.scimDatabricks,
        betaScim: true,
      },
      dialpad: {
        learnMore: KbArticleUrls.scimDialpad,
        betaScim: true,
      },
      docker: {
        learnMore: KbArticleUrls.scimDocker,
        betaScim: true,
      },
      druva: {
        learnMore: KbArticleUrls.scimDruva,
        betaScim: true,
      },
      egnyte: {
        learnMore: KbArticleUrls.scimEgnyte,
      },
      envoy: {
        learnMore: KbArticleUrls.scimEnvoy,
      },
      evernote: {
        learnMore: KbArticleUrls.scimEvernote,
      },
      figma: {
        learnMore: KbArticleUrls.scimFigma,
        betaScim: true,
      },
      forcepointprivateaccess: {
        learnMore: KbArticleUrls.scimForcepointPrivateAccess,
        betaScim: true,
      },
      getabstract: {
        betaScim: true,
        learnMore: KbArticleUrls.scimGetAbstract,
      },
      gitlab: {
        learnMore: KbArticleUrls.scimGitlab,
      },
      golinks: {
        betaScim: true,
        learnMore: KbArticleUrls.scimGolinks,
      },
      gong: {
        betaFeature: featureFlags.scimSupportGong,
        groupsBetaFeature: featureFlags.scimSupportGong,
        learnMore: KbArticleUrls.scimGong,
      },
      grammarly: {
        learnMore: KbArticleUrls.scimGrammarly,
        betaScim: true,
      },
      greenhouse: {
        betaScim: true,
        learnMore: KbArticleUrls.scimGreenhouse,
      },
      guru: {
        learnMore: KbArticleUrls.scimGuru,
      },
      heap: {
        learnMore: KbArticleUrls.scimHeap,
        betaScim: true,
      },
      hoxhunt: {
        betaScim: true,
        learnMore: KbArticleUrls.scimHoxhunt,
      },
      interact: {
        betaScim: true,
        learnMore: KbArticleUrls.scimInteract,
      },
      ironclad: {
        learnMore: KbArticleUrls.scimIronclad,
        betaScim: true,
      },
      island: {
        learnMore: KbArticleUrls.scimIsland,
      },
      jfrog: {
        learnMore: KbArticleUrls.scimJfrog,
        betaScim: true,
      },
      kandji: {
        learnMore: KbArticleUrls.scimKandji,
        betaScim: true,
      },
      keepersecurity: {
        learnMore: KbArticleUrls.scimKeeper,
      },
      kisi: {
        learnMore: KbArticleUrls.scimKisi,
      },
      knowbe4: {
        learnMore: KbArticleUrls.scimKnowbe4,
      },
      krisp: {
        betaScim: true,
        learnMore: KbArticleUrls.scimKrisp,
      },
      lattice: {
        learnMore: KbArticleUrls.scimLattice,
        betaScim: true,
      },
      leapsome: {
        learnMore: KbArticleUrls.scimLeapsome,
        betaScim: true,
      },
      looop: {
        learnMore: KbArticleUrls.scimLooop,
        betaScim: true,
      },
      lucidchart: {
        learnMore: KbArticleUrls.scimLucidchart,
        betaScim: true,
      },
      miro: {
        learnMore: KbArticleUrls.scimMiro,
        betaScim: true,
      },
      mixpanel: {
        learnMore: KbArticleUrls.scimMixpanel,
        betaScim: true,
      },
      monday: {
        learnMore: KbArticleUrls.scimMonday,
        betaScim: true,
      },
      mural: {
        learnMore: KbArticleUrls.scimMural,
        betaScim: true,
      },
      namely: {
        learnMore: KbArticleUrls.scimNamely,
      },
      netskope: {
        learnMore: KbArticleUrls.scimNetskope,
        betaScim: true,
      },
      newrelic: {
        learnMore: KbArticleUrls.scimNewrelic,
        betaScim: true,
      },
      ninjio: {
        learnMore: KbArticleUrls.scimNinjio,
        betaScim: true,
      },
      notion: {
        learnMore: KbArticleUrls.scimNotion,
        betaScim: true,
      },
      officespace: {
        learnMore: KbArticleUrls.scimOfficespace,
        betaScim: true,
      },
      onetrust: {
        learnMore: KbArticleUrls.scimOnetrust,
        betaScim: true,
      },
      oraclecloud: {
        learnMore: KbArticleUrls.scimOraclecloud,
        betaScim: true,
      },
      paylocity: {
        betaFeature: featureFlags.scimSupportPaylocity,
        betaScim: true,
        groupsBetaFeature: featureFlags.scimSupportPaylocity,
        learnMore: KbArticleUrls.scimPaylocity,
      },
      perimeter81: {
        betaScim: true,
        learnMore: KbArticleUrls.scimPerimeter81,
      },
      personio: {
        learnMore: KbArticleUrls.personio,
      },
      pipefy: {
        betaScim: true,
        learnMore: KbArticleUrls.scimPipefy,
      },
      printerlogicsaas: {
        learnMore: KbArticleUrls.scimPrinterlogicsaas,
      },
      profit: {
        learnMore: KbArticleUrls.scimProfit,
      },
      promapp: {
        learnMore: KbArticleUrls.scimPromapp,
      },
      pulumi: {
        betaScim: true,
        learnMore: KbArticleUrls.scimPulumi,
      },
      rhombussystems: {
        learnMore: KbArticleUrls.scimRhombus,
        betaScim: true,
      },
      ringcentral: {
        learnMore: KbArticleUrls.scimRingcentral,
      },
      robin: {
        learnMore: KbArticleUrls.scimRobin,
        betaScim: true,
      },
      salesforce: {
        learnMore: KbArticleUrls.scimSalesforce,
      },
      salesforcesandbox: {
        learnMore: KbArticleUrls.scimSalesforcesandbox,
      },
      saleshood: {
        betaScim: true,
        learnMore: KbArticleUrls.scimSalesHood,
      },
      segment: {
        learnMore: KbArticleUrls.scimSegment,
        betaScim: true,
      },
      sentry: {
        learnMore: KbArticleUrls.scimSentry,
      },
      showpad: {
        learnMore: KbArticleUrls.scimShowpad,
        betaScim: true,
      },
      sigma: {
        learnMore: KbArticleUrls.scimSigma,
      },
      slack: {
        learnMore: KbArticleUrls.scimSlack,
      },
      smartsheet: {
        betaScim: true,
        learnMore: KbArticleUrls.scimSmartsheet,
      },
      snowflake: {
        learnMore: KbArticleUrls.scimSnowflake,
      },
      spaceiq: {
        learnMore: KbArticleUrls.scimSpaceiq,
        betaScim: true,
      },
      sparkpost: {
        learnMore: KbArticleUrls.scimSparkpost,
      },
      splashtop: {
        learnMore: KbArticleUrls.scimSplashtop,
      },
      stackoverflowforteams: {
        betaScim: true,
        learnMore: KbArticleUrls.scimStackoverflowforteams,
      },
      strongdm: {
        learnMore: KbArticleUrls.scimStrongdm,
      },
      tableau: {
        learnMore: KbArticleUrls.scimTableau,
      },
      teamretro: {
        learnMore: KbArticleUrls.scimTeamretro,
      },
      teamviewer: {
        learnMore: KbArticleUrls.scimTeamviewer,
      },
      templafy: {
        betaScim: true,
        learnMore: KbArticleUrls.scimTemplafy,
      },
      terranova: {
        learnMore: KbArticleUrls.scimTerranova,
      },
      terratrue: {
        learnMore: KbArticleUrls.scimTerratrue,
      },
      thousandeyes: {
        learnMore: KbArticleUrls.scimThousandeyes,
      },
      thrivelearning: {
        learnMore: KbArticleUrls.scimThrivelearning,
      },
      trello: {
        betaScim: true,
        learnMore: KbArticleUrls.scimTrello,
      },
      twingate: {
        learnMore: KbArticleUrls.scimTwingate,
      },
      udemybusiness: {
        learnMore: KbArticleUrls.scimUdemybusiness,
        betaScim: true,
      },
      verkada: {
        learnMore: KbArticleUrls.scimVerkada,
      },
      vimeo: {
        betaScim: true,
        learnMore: KbArticleUrls.scimVimeo,
      },
      workgrid: {
        betaScim: true,
        learnMore: KbArticleUrls.scimWorkgrid,
      },
      workivawdesk: {
        learnMore: KbArticleUrls.scimWorkivawdesk,
        betaScim: true,
      },
      workplacebyfacebook: {
        learnMore: KbArticleUrls.scimWorkplacebyfacebook,
      },
      workramp: {
        learnMore: KbArticleUrls.scimWorkramp,
        betaScim: true,
      },
      zeplin: {
        learnMore: KbArticleUrls.scimZeplin,
        betaScim: true,
      },
      zoom: {
        learnMore: KbArticleUrls.scimZoom,
      },
      zscaler: {
        learnMore: KbArticleUrls.scimZscaler,
        betaScim: true,
      },
    };
  },
};

export default {
  computed: {
    ...mapGetters('FeatureFlagsModule', { featureFlags: 'betaFeatures' }),
  },

  methods: {
    getScimLearnMore(name) {
      const scimApplications = scimAppsDictionary.getAppsWithScimSupport();
      return scimApplications[name].learnMore;
    },

    hardcodedIsScimSupported(name) {
      const scimApplications = scimAppsDictionary.getAppsWithScimSupport();
      const appsWithScimSupport = Object.keys(scimApplications);
      return appsWithScimSupport.some(appName => appName === name);
    },

    hasBetaFeature(name) {
      const scimApplications = scimAppsDictionary.getAppsWithScimSupport();
      if (scimApplications[name]) {
        return !!scimApplications[name].betaFeature;
      }
      return false;
    },

    // we can addd betaScim attribute for Beta Apps
    isBetaScim(name) {
      const scimApplications = scimAppsDictionary.getAppsWithScimSupport();
      return scimApplications[name] ? !!scimApplications[name].betaScim : false;
    },

    hasLearnMore(name) {
      const scimApplications = scimAppsDictionary.getAppsWithScimSupport();
      return !!(scimApplications[name] && scimApplications[name].learnMore);
    },

    isBetaflagActive(name) {
      const scimApplications = scimAppsDictionary.getAppsWithScimSupport();
      const appsWithScimSupport = Object.keys(scimApplications);

      if (scimApplications[name] && scimApplications[name].betaFeature) {
        const betaFeatureName = scimApplications[name].betaFeature;
        return appsWithScimSupport
          .some(() => (
            this.featureFlags[betaFeatureName]
          ));
      }
      return false;
    },

    isGroupsBetaFlagActive(name) {
      const scimApplications = scimAppsDictionary.getAppsWithScimSupport();
      const appsWithScimSupport = Object.keys(scimApplications);

      if (scimApplications[name] && scimApplications[name].groupsBetaFeature) {
        const betaFeatureName = scimApplications[name].groupsBetaFeature;
        return appsWithScimSupport
          .some(() => (
            this.featureFlags[betaFeatureName]
          ));
      }
      return false;
    },
  },
};
